/* Activities.tsx
    Une page affichant la gestion des activités
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les éléments
    Utilise l'API correspondante pour les opérations de données
*/

import { MainButton } from 'common';
import {
	faArrowRight,
	faChartLine,
	faPersonArrowDownToLine,
} from '@fortawesome/free-solid-svg-icons';
import { ActivitiesCrudCard } from 'features/activities/components/ActivityCrudCard';
import PageHeader from 'layout/PageHeader';
import WidgetSection from 'layout/WidgetSection';
import WidgetHeader from 'layout/WidgetHeader';

export const Activities = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faChartLine}
			title="Activités"
			subtitle="Gérez les activités de vos clients et en interne"
		/>
		<WidgetSection className="mt-6">
			<WidgetHeader
				icon={faPersonArrowDownToLine}
				title="Générez des activités à partir des badges de vos clients"
			/>
			<div className="ml-8">
				<MainButton
					label="Aller sur la page dédiée"
					onClick={() => {
						location.href = '/app/activities/from-badge';
					}}
					icon={faArrowRight}
				/>
			</div>
		</WidgetSection>
		<ActivitiesCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);
